import { useEffect, useState } from 'react'
import { Boton } from '@ui/primitivas/Boton'
import { descargarPlanDeMedidas, obtenerPlanDeMedidas } from './clienteDeMatrices'
import type { Matriz, PlanDeMedidas as Plan } from './tipos'

export function PlanDeMedidas({ matriz }: { matriz: Matriz }) {
  const [plan, setPlan] = useState<Plan | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [descargando, setDescargando] = useState(false)

  useEffect(() => {
    if (!matriz.revisiones.length) return
    let vigente = true
    obtenerPlanDeMedidas(matriz.id)
      .then((resultado) => { if (vigente) setPlan(resultado) })
      .catch(() => { if (vigente) setError('No fue posible cargar el plan de medidas.') })
    return () => { vigente = false }
  }, [matriz.id, matriz.revision_actual, matriz.revisiones.length])

  if (!matriz.revisiones.length) return <p role="status">Confirma la matriz para generar el plan de medidas.</p>
  if (error) return <p role="alert" className="text-critico-texto">{error}</p>
  if (!plan) return <p role="status">Preparando el plan de medidas…</p>

  return (
    <section className="grid gap-4" aria-labelledby="titulo-plan">
      <div>
        <p className="text-etiqueta text-marca">REVISIÓN OFICIAL {plan.revision}</p>
        <h2 id="titulo-plan" className="text-h2">Plan de medidas</h2>
        <p className="text-pequeno text-texto-secundario">{plan.aviso}</p>
      </div>
      <div>
        <Boton
          trabajando={descargando}
          alPulsar={() => {
            setDescargando(true)
            descargarPlanDeMedidas(matriz.id, plan.revision)
              .catch(() => setError('No fue posible descargar el plan.'))
              .finally(() => setDescargando(false))
          }}
        >Descargar plan (.xlsx)</Boton>
      </div>
      <p className="text-pequeno">{plan.acciones.length} medida(s) de la revisión oficial, ordenadas por nivel de riesgo. Las evaluaciones por protocolo aparecen al final.</p>
      <ol className="grid gap-3">
        {plan.acciones.map((accion) => (
          <li key={accion.id} className="rounded-xl border border-borde bg-superficie p-4">
            <p className="text-etiqueta text-marca">{accion.nivel ?? 'Pendiente de protocolo'} · {accion.prelacion}</p>
            <h3 className="text-cuerpo font-semibold">{accion.medida}</h3>
            <p className="text-pequeno text-texto-secundario">{accion.proceso} / {accion.area} / {accion.tarea}</p>
            <p className="text-pequeno">Riesgo: {accion.riesgo_codigo ? `${accion.riesgo_codigo} · ` : ''}{accion.riesgo}</p>
            <p className="text-pequeno text-atencion-texto">Responsable y fecha: por definir.</p>
          </li>
        ))}
      </ol>
    </section>
  )
}
